<template>
  <MarketCard>
    <div :class="classes.cardHeader">
      <CardHeader :class="classes.datesport" :eventId="eventId" />
      <MarketName :marketId="marketId" :class="classes.market" />
    </div>
    <div :class="classes.cardContent">
      <div :class="classes.optionWrapper">
        <EventNames
          :class="[classes.eventName, 'event-name']"
          :marketId="marketId"
          :eventId="eventId"
          :useTeamNames="true"
        />
      </div>
      <div :class="classes.marketOptions">
        <WinOption
          :stagger="0"
          :class="[classes.marketOption, 'team-one']"
          :eventId="eventId"
          :optionId="ftrMarkets[0].options[0]"
        />
        <WinOption
          :stagger="1"
          :eventId="eventId"
          :isDraw="true"
          :class="[classes.marketOption, 'draw']"
          :optionId="ftrMarkets[0].options[1]"
        />
        <WinOption
          :stagger="2"
          :class="[classes.marketOption, 'team-two']"
          :eventId="eventId"
          :optionId="ftrMarkets[0].options[2]"
        />
      </div>
    </div>
  </MarketCard>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { computed, defineComponent, ref } from "vue";

import MarketName from "../../../MarketName.vue";
import CardHeader from "../../../CardHeaderLeaderboard.vue";
import MarketCard from "../../../styled/MarketCard.vue";
import WinOption from "../../../WinOption.vue";
import EventNames from "../../../EventNameBadges.vue";

import {
  composeHomeAwayOptions,
  composeEventCompetitors
} from "@fresh8/ad-data-composition/src/betData";
import { injectCarouselContext } from "../../../../lib/provideInjectors";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";

const useStyles = createUseStyles({
  cardContent: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center"
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "5px",
    height: "14px",
    borderBottom: props => `1px solid ${props.marketBorderColor}`
  },
  datesport: {
    "& span": {
      fontSize: "10px !important"
    }
  },
  market: {
    paddingRight: "6px"
  },
  marketOptions: {
    flex: 1,
    display: "flex",
    width: "100%"
  },
  marketOption: {
    flex: "1 1 50%",
    minHeight: "0px",
    border: "none !important",
    justifyContent: "space-between",
    paddingTop: "6px !important",

    "&.draw": {
      flex: "1 1 30%",
      minWidth: "60px",
      margin: "0",
      paddingLeft: "0",
      paddingRight: "0"
    },
    "&:first-of-type": {
      marginRight: "4px"
    },
    "&:last-of-type": {
      marginLeft: "4px"
    },
    "& div": {
      textAlign: "center"
    },
    "& > span": {
      display: "none"
    },
    "& .odds-text": {
      fontSize: "11px"
    }
  },
  optionWrapper: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    flex: 1
  },
  eventName: {
    "& .competitors .banner": {
      maxWidth: "unset",
      "&.right": {
        marginLeft: "25px"
      },
      "&.left": {
        marginRight: "25px"
      }
    },

    "&.vs": {
      flex: 0,
      margin: "0 4px"
    },
    "& .banner .badge,.banner .jersey": {
      width: props => (props.carouselContext ? "20%" : "15%"),
      maxWidth: "51px",
      minWidth: "41px",
      margin: "0 4px"
    }
  }
});

export default defineComponent({
  name: "Card",
  components: {
    MarketCard,
    CardHeader,
    MarketName,
    WinOption,
    EventNames
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const brandContext = injectBrand();
    const carouselContext = injectCarouselContext();
    const marketId = ref([props.marketId]);
    const classesRef = useStyles(
      computed(() => ({
        carouselContext: carouselContext.value.isCarousel,
        ...brandContext?.adTemplateBranding.value
      }))
    );
    const ftrMarkets = composeHomeAwayOptions(marketId);
    const competitors = composeEventCompetitors(props.eventId);

    return {
      competitors,
      classes: classesRef,
      ftrMarkets
    };
  }
});
</script>

<style></style>
